<template>
  <button
    type="button"
    :disabled="disabled"
    @click="$emit('click')"
    class="group inline-flex h-10 items-center gap-2 border-b-2 border-transparent bg-transparent px-3 scio-text-body scio-weight-semibold text-slate-700 transition hover:bg-neutral-50 hover:text-neutral-950 focus:outline-none focus-visible:ring-2 focus-visible:ring-scio-yellow-p3 disabled:cursor-not-allowed disabled:opacity-50"
    :class="active ? 'border-scio-yellow-p3 text-neutral-950' : ''"
  >
    <img :src="icon" alt="" class="h-4 w-4 opacity-80" />
    <span class="hidden sm:inline">{{ label }}</span>
  </button>
</template>

<script setup>
defineProps({
  label: { type: String, required: true },
  icon: { type: String, required: true },
  active: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
});

defineEmits(["click"]);
</script>
